// extracted by mini-css-extract-plugin
module.exports = {"managedFileInfo":"managedFileInfo_managedFileInfo__4TFoX","label":"managedFileInfo_label__qEWgV"};